@if (error) {
  <span>
    <i class="icon icon-error"></i>
    <em [textContent]="error"></em>
  </span>
}
@if (!!resource) {
  <display-field [resource]="resource"
    containerType="single-view"
    [displayFieldOptions]="{ writable: false }"
    [fieldName]="fieldName" />
}
